export default "__VITE_ASSET__85Yu3CJL__"